import { ThunkType } from "../../../../core/store/reducers";
import { deleteAlarmApi } from "../api/deleteAlarm";
import { setFetchState, invalidateAlarm } from "../alarmDataSlice";

export const deleteAlarm = (dalarmId: string): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return;
  }

  dispatch(setFetchState({ type: "started" }));

  const { userId } = store.data.auth.current.user;
  const result = await dispatch(deleteAlarmApi(userId, dalarmId));

  dispatch(
    setFetchState(
      result !== undefined ? { type: "successful" } : { type: "error" }
    )
  );
  dispatch(invalidateAlarm())
};
